import React, { Suspense } from 'react';
import { v4 as uuid } from 'uuid';

import CONST from "../config/CONST";
import components from "./reactComponents";
import SuspenseLoading from "./components/SuspenseLoading/SuspenseLoading";
import ReactDOM from "react-dom/client";

const renderedComponents = {};

const renderComponent = (el) => {

    if(CONST.DEBUG) {
        console.log("React component <"+el.dataset.reactComponent+">: initializing...");
        console.log("React component mountpoint: #" + el.id);
    }

    let ReactComponent = components[ el.dataset.reactComponent ];
    if (typeof ReactComponent !== "undefined") {
        let props = {};
        if(typeof el.dataset.props !== "undefined") {
            props = JSON.parse(el.dataset.props);
        }

        if(el.innerHTML !== "") {
            props.innerHTML = el.innerHTML;
        }
        const componentRoot = ReactDOM.createRoot(el);

        componentRoot.render(<Suspense fallback={<SuspenseLoading/>}><ReactComponent {...props} /></Suspense>);
        renderedComponents[el.id] = componentRoot;

        el.classList.add("is-ready");

        if(CONST.DEBUG) {
            console.log("React component <"+el.dataset.reactComponent+">: initialized");
            console.log("React component <"+el.dataset.reactComponent+">: props", props);
        }
    }
    else {
        if(CONST.DEBUG) {
            console.warn("Component <"+el.dataset.reactComponent+">: not found");
        }
    }

}

const reactBoostrapper = {

    init: () => {
        const domElements = document.querySelectorAll("[data-react-component]");
        domElements.forEach(function(el) {
            if(!el.id) {
                el.id = uuid();
            }
            renderComponent(el)
        });
    },

    update: (mountpointId) => {
        const el = document.getElementById(mountpointId);
        if(el) {
            el.classList.remove("is-ready");
            if(renderedComponents[mountpointId]) {
                renderedComponents[mountpointId].unmount();
            }
            renderComponent(el);
        }
    },

    updateAll: () => {
        const domElements = document.querySelectorAll("[data-react-component]");
        domElements.forEach(function(el) {
            reactBoostrapper.update(el.id);
        });
    }

}

export default reactBoostrapper;